import * as stylex from '@stylexjs/stylex';
import { FC } from 'react';
import { styles } from '../../styles';
import { InvitationStatusBlock } from '@features/event-participant-card/ui/invitation-status-block';
import { Ticket, InvitationStatusTicketEnum } from '@pages/event/api/useFetchTicketSegment';

interface InvitationStatusSectionProps {
  ticket: Ticket;
  inviteStatus: InvitationStatusTicketEnum | null;
  isDropdownOpen: boolean;
  sendTicketAfterAcceptAt?: string | null;
  dropdownRef: React.RefObject<HTMLButtonElement>;
  onToggleDropdown: () => void;
  onCloseDropdown: () => void;
  onSelectAccepted: () => void;
  onSelectDeclined: () => void;
  eventDateEnd?: string;
}

export const InvitationStatusSection: FC<InvitationStatusSectionProps> = ({
  ticket,
  inviteStatus,
  isDropdownOpen,
  sendTicketAfterAcceptAt,
  dropdownRef,
  onToggleDropdown,
  onCloseDropdown,
  onSelectAccepted,
  onSelectDeclined,
  eventDateEnd,
}) => {
  return (
    <section {...stylex.props(styles.statusBlock)}>
      <div {...stylex.props(styles.statusBlockItem)}>
        <div {...stylex.props(styles.dataBlockTitle)}>Приглашение</div>
        <div {...stylex.props(styles.dataFields)}>
          <div {...stylex.props(styles.statusField)}>
            <span {...stylex.props(styles.dataFieldLabel)}>СМС:</span>
            <span {...stylex.props(styles.dataFieldValue)}>
              {ticket.smsInviteSent ? 'Отправлено' : 'Не отправлено'}
            </span>
          </div>
          <div {...stylex.props(styles.statusField)}>
            <span {...stylex.props(styles.dataFieldLabel)}>E-mail:</span>
            <span {...stylex.props(styles.dataFieldValue)}>
              {ticket.emailInviteSent ? 'Отправлено' : 'Не отправлено'}
            </span>
          </div>
        </div>
        <InvitationStatusBlock
          ticket={{ ...ticket, invitationStatus: inviteStatus }}
          isDropdownOpen={isDropdownOpen}
          sendTicketAfterAcceptAt={sendTicketAfterAcceptAt}
          dropdownRef={dropdownRef}
          onToggleDropdown={onToggleDropdown}
          onCloseDropdown={onCloseDropdown}
          onSelectAccepted={onSelectAccepted}
          onSelectDeclined={onSelectDeclined}
          eventDateEnd={eventDateEnd}
        />
      </div>
    </section>
  );
};
